module.exports = new __parcel__URL__("MMIRL8.218a9cfd.jpg").toString();